import Vue from 'vue';
import { HTTP, baseUploadURL } from './axios';

Vue.prototype.$baseUploadURL = baseUploadURL;
Vue.prototype.$http = HTTP;
